export const CHANGE_MENU = 'CHANGE_MENU'
export const SET_MENU = 'SET_MENU'
export const REST_MENU = 'REST_MENU'
export const REMOVE_MENU = 'REMOVE_MENU'